import React from 'react'
import Staff5 from '../../Images/HR/OtherSubCommittee/AnishShrestha.jpg'
import Staff12 from '../../Images/HR/Staffs/AnushaPaudelGhimire.jpg'
import Staff3 from '../../Images/HR/Staffs/BhumikaAdhikari.jpg'
import Staff17 from '../../Images/HR/Staffs/BimaladeviGhimire.jpg'
import Staff16 from '../../Images/HR/Staffs/ChandrakalaAcharya.jpg'
import Staff6 from '../../Images/HR/Staffs/DayasagarRai.jpg'
import Staff4 from '../../Images/HR/OtherSubCommittee/GitaKumariGhimire.jpg'
import Staff1 from '../../Images/HR/OtherSubCommittee/GopalDeuja.JPG'
import Staff2 from '../../Images/HR/OtherSubCommittee/HirachandraPokhrel.JPG'
import Staff11 from '../../Images/HR/Staffs/khemrajDahal.jpg'
import Staff7 from '../../Images/HR/OtherSubCommittee/MamataKhatiwada.jpg'
import Staff14 from '../../Images/HR/Staffs/MukeshChaudhary.jpg'
import Staff9 from '../../Images/HR/Staffs/NabinBastola.JPG'
import Staff13 from '../../Images/HR/Staffs/RadhikaShrestha.jpg'
import Staff10 from '../../Images/HR/Staffs/RamaBhandari.JPG'
import Staff19 from '../../Images/HR/Staffs/RoshniShrestha.jpg'
import Staff20 from '../../Images/HR/Staffs/SangitaChapagai.jpg'
import Staff8 from '../../Images/HR/Staffs/UmeshShrestha.jpg'
import Staff18 from '../../Images/HR/Staffs/PramilaAacharya.jpg'
import Aos from 'aos'

const Staffs = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    const staffList = [
        {
            id: '1',
            memName: 'गोपाल देउजा',
            post: 'ब्यवस्थापक',
            memImg: Staff1
        },
        {
            id: '2',
            memName: 'हिराचन्द्र पोखरेल',
            post: 'लेखा अधिकृत',
            memImg: Staff2
        },
        {
            id: '3',
            memName: 'भुमिका अधिकारी',
            post: 'वरिष्ठ कार्यालय सहायक',
            memImg: Staff3
        },
        {
            id: '4',
            memName: 'गिताकूमारी घिमिरे',
            post: 'वरिष्ठ कार्यालय सहायक',
            memImg: Staff4
        },
        {
            id: '5',
            memName: 'अनिश श्रेष्ठ',
            post: 'कार्यालय सहायक चौथो प्रथम',
            memImg: Staff5
        },
        {
            id: '6',
            memName: 'दयासागर राई',
            post: 'कार्यालय सहायक चौथो प्रथम',
            memImg: Staff6
        },
        {
            id: '7',
            memName: 'ममता खतिवडा',
            post: 'कार्यालय सहायक चौथो प्रथम',
            memImg: Staff7
        },
        {
            id: '8',
            memName: 'उमेश श्रेष्ठ',
            post: 'कार्यालय सहायक चौथो प्रथम',
            memImg: Staff8
        },
        {
            id: '9',
            memName: 'नविन वास्तोला',
            post: 'कार्यालय सहायक चौथो द्धितिय',
            memImg: Staff9
        },
        {
            id: '10',
            memName: 'रमा भण्डारी',
            post: 'कार्यालय सहायक चौथो द्धितिय',
            memImg: Staff10
        },
        {
            id: '11',
            memName: 'खेमराज दाहाल',
            post: 'कार्यालय सहायक चौथो द्धितिय',
            memImg: Staff11
        },
        {
            id: '12',
            memName: 'अनूषा पौडेल घिमिरे',
            post: 'कार्यालय सहायक चौथो द्धितिय',
            memImg: Staff12
        },
        {
            id: '13',
            memName: 'राधिका श्रेष्ठ',
            post: 'कार्यालय सहायक चौथो तृतिय',
            memImg: Staff13
        },
        {
            id: '14',
            memName: 'मूकेश चौधरी',
            post: 'कार्यालय सहायक चौथो तृतिय',
            memImg: Staff14
        },
        {
            id: '15',
            memName: 'चन्द्रकला आचार्य',
            post: 'कार्यालय सहायक चौथो तृतिय',
            memImg: Staff16
        },
        {
            id: '16',
            memName: 'विमलादेवी घिमिरे',
            post: 'कार्यालय सहायक चौथो तृतिय',
            memImg: Staff17
        },
        {
            id: '17',
            memName: 'रोस्नी श्रेष्ठ',
            post: 'कार्यालय सहायक चौथो तृतिय',
            memImg: Staff19
        },
        {
            id: '18',
            memName: 'संगिता चापागाई',
            post: 'कार्यालय सहायोगी',
            memImg: Staff20
        },
        {
            id: '19',
            memName: 'प्रमिला आचार्य',
            post: 'कार्यालय सहायक',
            memImg: Staff18
        },
    ]

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>कनकलक्ष्मी साकोस :: कर्मचारीहरू</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {staffList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' loading='lazy' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default Staffs